import { landingDomainService } from "Apis";
import { useProjectSharedState } from "./useSharedState";
import { ApiDomainResponse, ApiProject } from "@incendium/api";

const fetchSubdomains = async (selectedProject: ApiProject | null) => {
  if (selectedProject) {
    const subdomains =
      await landingDomainService.landingDomainServiceListDomains({
        projectId: selectedProject.id as number,
      });
    return subdomains.results || [];
  }
  return [];
};
export const useSubdomains = () => {
  const { state, setState, refetch, loading, fetched } = useProjectSharedState<
    ApiDomainResponse[]
  >("subdomains", [], fetchSubdomains);

  return {
    subdomains: state,
    setSubdomains: setState,
    refetch,
    loading,
    fetched,
  };
};
